import styled from 'styled-components';

type AnimatedType = {
  visible?: boolean;
};

export const AnimatedSlideDownView = styled.div<AnimatedType>`
  transition: all 0.2s;
  height: ${({ visible }) => (visible ? 'auto' : 0)};
  overflow-y: hidden;
  overflow-x: visible;

  & > * {
    opacity: ${({ visible }) => (visible ? 1 : 0)};
    transition: ease-out 0.2s;
  }
`;
